// extracted by mini-css-extract-plugin
export default {"comment":"WarningIcon_comment__TpzDT","exclamationPoint":"WarningIcon_exclamationPoint__1cTWH"};